export const phoneUsRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
//eslint-disable-next-line
export const phoneIntRegex = /^[\+\(\s.\-\/\d\)]{5,30}$/;
export const emailRegex = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
export const onlyNumericRegex = /\d+/g;
